import React from "react";

export default ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <g clipPath="url(#clip0)">
      <path
        d="M4.57257 2.22617C4.76329 2.02877 5.08073 2.02877 5.27812 2.22617C5.46885 2.4169 5.46885 2.73433 5.27812 2.92461L1.70054 6.50219L13.5061 6.5022C13.7813 6.50264 14 6.72138 14 6.99658C14 7.27177 13.7813 7.49762 13.5061 7.49762L1.70054 7.49762L5.27812 11.0685C5.46885 11.2659 5.46885 11.5838 5.27812 11.7741C5.08072 11.9715 4.76285 11.9715 4.57256 11.7741L0.148049 7.34957C-0.0493463 7.15885 -0.0493463 6.84141 0.148049 6.65113L4.57257 2.22617Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="14"
          height="14"
          fill="currentColor"
          transform="matrix(-1 -2.62268e-07 -2.62268e-07 1 14 0)"
        />
      </clipPath>
    </defs>
  </svg>
);



// WEBPACK FOOTER //
// ./src/components/Icons/IconArrowLeft.js